// A tiny wrapper around ResizeObserver to avoid the 'ResizeObserver loop completed'
// warnings by ensuring callbacks run in a requestAnimationFrame break. This is a
// pragmatic fix that avoids synchronous callback loops while preserving behavior.
// Import early in your app (see src/index.js) so 3rd-party libs use the wrapped RO.
/* eslint-disable no-var */
if (typeof window !== "undefined" && typeof window.ResizeObserver === "function") {
  (function () {
    const NativeRO = window.ResizeObserver;
    function WrappedResizeObserver(cb) {
      // Keep a reference to the original callback to support disconnect and observe.
      const wrappedCb = function (entries, observer) {
        // schedule the real callback for the next animation frame
        if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
          window.requestAnimationFrame(() => cb(entries, observer));
        } else {
          // fallback
          cb(entries, observer);
        }
      };
      return new NativeRO(wrappedCb);
    }

    // Copy the prototype so code checking instanceof ResizeObserver still works
    WrappedResizeObserver.prototype = NativeRO.prototype;
    // Preserve the native toString
    WrappedResizeObserver.toString = function () {
      return NativeRO.toString();
    };

    // Replace global
    window.ResizeObserver = WrappedResizeObserver;
  })();
}
